import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorProperties } from '../../API/identityAPIProperties';
import API from '../../API/Main/API';
import { resetState } from '../../resetState';
import { InsuranceAuthorizationTypeProperties } from '../../API/ClientAPIHelpers/insuranceAuthorizationProperties';

export const getAuthorizationTypes = createAsyncThunk('user/authorization/types', async (_, thunkAPI) => {
	const response = await API.UserAPI.Authorization.getAuthorizationTypes();

	if (response.error) {
		return thunkAPI.rejectWithValue(response.error);
	}

	return response as InsuranceAuthorizationTypeProperties[];
});

interface AuthorizationInitialStateProperties {
	authorizationTypes: InsuranceAuthorizationTypeProperties[];
	error: ErrorProperties;
	loading: boolean;
}

const initialAuthorizationState: AuthorizationInitialStateProperties = {
	loading: false,
	error: {
		status: 0,
		title: '',
	},
	authorizationTypes: [],
};

const authorizationSlice = createSlice({
	name: 'authorization',
	initialState: initialAuthorizationState,
	reducers: {},
	extraReducers: (builder) => {
		// getAuthorizationTypes
		builder.addCase(getAuthorizationTypes.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(getAuthorizationTypes.fulfilled, (state, action) => {
			state.loading = false;
			state.authorizationTypes = action.payload;
		});
		builder.addCase(getAuthorizationTypes.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload as ErrorProperties;
		});

		// reset state
		builder.addCase(resetState, () => initialAuthorizationState);
	},
});

export default authorizationSlice.reducer;
